// import { useEffect, useState } from 'react';
// import {
// 	AuthenticatedTemplate,
// 	UnauthenticatedTemplate,
// 	useMsal,
// 	useAccount,
// } from '@azure/msal-react';
// import { useSelector, useDispatch } from 'react-redux';
// import Router from './Router';
// import { loginRequest } from './auth.config';
// import { getUserInfo } from './Services/UserService';
// import { login } from './Store/authSlice';
// import { setCurrentRole } from './Store/roleSlice';

// const Pages = () => {
// 	const { instance, accounts } = useMsal();
// 	const activeAccount = instance.getActiveAccount();
// 	const account = useAccount(accounts[0] || {});
// 	const dispatch = useDispatch();
// 	const user = useSelector((state) => state?.auth?.user);
// 	// const [unauthorized, setUnauthorized] = useState(false);
// 	const [forbidden, setForbidden] = useState(false);

// 	async function callHandleRedirectPromise(instanceObj) {
// 		await instanceObj.handleRedirectPromise;
// 	}
// 	useEffect(() => {
// 		callHandleRedirectPromise(instance);

// 		if (account) {
// 			localStorage.setItem('AccessToken', account.idToken);
// 			if (!user) {
// 				getUserInfo()
// 					.then((userInfo) => {
// 						dispatch(login(userInfo));
// 						const currentRole = userInfo?.userRole;
// 						dispatch(setCurrentRole(currentRole));
// 					})
// 					.catch((err) => {
// 						console.warn(err);
// 						if (err?.response?.status === 401) {
// 							// setUnauthorized(true);
// 						} else if (err?.response?.status === 403) {
// 							setForbidden(true);
// 						}
// 					});
// 			}
// 		}
// 	}, [account, instance]);

// 	const handleRedirect = () => {
// 		instance
// 			.loginRedirect({ ...loginRequest, prompt: 'login' })
// 			.catch((error) => console.error(error));
// 	};

// 	return (
// 		<div>
// 			<UnauthenticatedTemplate>
// 				{activeAccount?.idToken !== undefined ? null : handleRedirect()}
// 			</UnauthenticatedTemplate>
// 			<AuthenticatedTemplate>
// 				{account && !forbidden ? (
// 					<Router />
// 				) : (
// 					<h1>
// 						{
// 							"You don't have permission to access PartsExList. Please contact the admin"
// 						}
// 					</h1>
// 				)}
// 			</AuthenticatedTemplate>
// 		</div>
// 	);
// };

// export default Pages;






import { useEffect, useState } from 'react';
import {
  AuthenticatedTemplate,
  useMsal,
  useAccount,
} from '@azure/msal-react';
import { useSelector, useDispatch } from 'react-redux';
import Router from './Router';
import { loginRequest } from './auth.config';
import { getUserInfo } from './Services/UserService';
import { login } from './Store/authSlice';
import { setCurrentRole } from './Store/roleSlice';
import { useTranslation } from 'react-i18next';
import i18n from './utils/i18n';
import Backend from 'i18next-http-backend';

const Pages = () => {
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const account = useAccount(accounts[0] || {});
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth?.user);
			   
  const [forbidden, setForbidden] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
										   
    instance.handleRedirectPromise().catch((err) => console.error('Redirect error:', err));
	  
    if (account) {
      
      //  Lazy-load translations after login
      i18n
        .use(Backend)
        .init({
          backend: {
            loadPath: (lng) => {
              const fileMap = {
                en: 'English',
                bg: 'Bulgarian',
                cs: 'Czech',
                da: 'Danish',
                de: 'German',
                el: 'Greek',
                et: 'Estonian',
                fi: 'Finnish',
                fr: 'French',
                hu: 'Hungarian',
                it: 'Italian',
                lv: 'Latvian',
                lt: 'Lithuanian',
                nl: 'Dutch',
                no: 'Norwegian',
                pl: 'Polish',
                pt: 'Portuguese',
                ro: 'Romanian',
                sk: 'Slovakian',
                sl: 'Slovenian',
                es: 'Spanish',
                sv: 'Swedish'
              };
              const fileName = fileMap[lng] || lng;
              return `/locales/${fileName}.json`;
            }
          },
          lng: 'English',
          fallbackLng: 'English'
        })
        .then(() => i18n.changeLanguage('English'));

      localStorage.setItem('AccessToken', account.idToken);
      if (!user) {
        getUserInfo()
          .then((userInfo) => {
            dispatch(login(userInfo));
            const currentRole = userInfo?.userRole;
            dispatch(setCurrentRole(currentRole));
          })
          .catch((err) => {
            console.warn(err);
            if (err?.response?.status === 403) {
              setForbidden(true);
            }
          });
      }
    }
  }, [account, instance, user, dispatch]);

									  
  useEffect(() => {
    if (!activeAccount) {
      instance.loginRedirect({ ...loginRequest, prompt: 'login' }).catch((error) => console.error(error));
    }
  }, [activeAccount, instance]);
   

  return (
    <div>
      <AuthenticatedTemplate>
        {account && !forbidden ? (
          <>
            <h1>{t('appTitle')}</h1>
            <Router />
          </>
        ) : (
          <h1>{t('forbiddenMessage')}</h1>
	   
        )}
      </AuthenticatedTemplate>
    </div>
  );
};

export default Pages;
